<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         

        

        <z-page title="Arahan Pembayaran " class="mt3">
              <w-form >
                
                <w-flex class="mt4">
                       <div class="xs4 mr5">
                          <w-input v-model="cari.no_bayaran">No. Bayaran</w-input>
                      </div>
                      <div class="xs4 mr5">
                        <z-lookup label="Kod Akaun" name="akaun" :url='service_utiliti+"lookup/akaun_akhir"' :sort="false" :cache="false" v-model="cari.akaun_id"  />
                      </div>
                      <div class="xs4">
                        <w-input  v-model="cari.profil">Nama Penerima Bayaran</w-input>
                      </div>
                </w-flex>
                <w-flex class="mt4">
                       <div class="xs4 mr5">
                          <w-input v-model="cari.tarikh" type="date">Tarikh Daftar</w-input>
                      </div>
                      <div class="xs4 mr5">
                        <z-lookup label="Status" name="status" :url='service_pembayaran+"lookup/lkp_status"' :sort="false" :cache="false" v-model="cari.lkp_bayaran_status_id"  />
                      </div>
                      <div class="xs4">
                        
                      </div>
                </w-flex>

            </w-form>

             <div class="mt2 text-right">
                
                <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                   <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                </w-button>
                <w-button class="ml1 " @click="search()">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button>
             </div>
             <z-table ref="tbluser" title="Senarai" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
                
                <template #item-cell.action="{ item, label, header, index }">
                  <w-flex class="flex justify-center">

                    <template v-if="(item.lkp_bayaran_status_id == 1 || item.lkp_bayaran_status_id == 5) && $zutil.can('Bayaran Penyediaan')">
                       <inertia-link :href='$route("bayaran.semak",item.id)'>
                        <w-tooltip top>
                           <template #activator="{ on }">
                             <w-icon v-on="on" >
                               fal fa-pencil
                             </w-icon>
                           </template>
                           Papar
                         </w-tooltip>
                        </inertia-link>
                    </template>
                    <template v-else>
                       <inertia-link :href='$route("bayaran.show",item.id)'>
                        <w-tooltip top>
                           <template #activator="{ on }">
                             <w-icon v-on="on" >
                               fal fa-file
                             </w-icon>
                           </template>
                           Papar
                         </w-tooltip>
                        </inertia-link>
                    </template>
                  </w-flex>
                </template>
                <template #item-cell.profil="{ item, label, header, index }">
                  <template v-for="dt, index in item.butiran">
                    <w-tag class="mr4">{{dt.profil_nama}}</w-tag>
                  </template>
                </template>
                <template #item-cell.amaun="{ item, label, header, index }">
                  
                  {{$zutil.currency(item.amaun)}}
                </template>
            </z-table>
        </z-page>



    </zen-one>
</template>

<script>
import { reactive } from 'vue'
// import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    //  
  },
  data() {
    return {
        resourceurl: this.service_pembayaran+'bayaran',
        reload: true,
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'iHasil', route: '/' },
        { label: 'Bayaran', route: '/bayaran' },
        { label: 'Senarai', route: '/bayaran' },
          ],
          form: {
            // id: 0,
            no: '',
            no_dokumen: '',
            },
           cari : {no_bayaran: '', akaun_id : '', profil : '', tarikh : '', lkp_bayaran_status_id : ''}
    }
       
  },
  methods: {

    search() {
      var url = window.route('bayaran.index')+'?no_bayaran='+this.cari.no_bayaran+'&akaun_id='+this.cari.akaun_id+'&profil='+this.cari.profil+'&tarikh='+this.cari.tarikh+'&lkp_bayaran_status_id='+this.cari.lkp_bayaran_status_id;
      this.$inertia.visit(url, { preserveScroll : true})
    },

    reset(){
      this.cari = {no_bayaran: '', akaun_id : '', profil : '', tarikh : '', lkp_bayaran_status_id : ''}
      this.search()
    },
       
  },
  watch: {
    
  },
  mounted() {
    // override default setting
    this.dialog.width = 500

    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari.no_bayaran == 'undefined'){this.cari.no_bayaran = ''}
    if(this.cari.profil == 'undefined'){this.cari.profil = ''}
    if(this.cari.tarikh == 'undefined'){this.cari.tarikh = ''}
      
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>